<template>
  <div>
    <div class="boxFoot">
      <div style="width: 1200px;margin: 0 auto;" class="flex align-center justify-between">
        <div class="boxFootLeft">
          <div class="img">
            <img src="@/assets/images/tel.png" alt="">
          </div>
          <div class="tex">
            <div class="texTop">服务电话：400-999-6541</div>
            <div class="texBottom">周一至周日8:00 - 12:00</div>
          </div>
        </div>

        <div class="boxFootRight flex align-center justify-between">
          <div>
            <div class="img">
              <img src="@/assets/images/erweima_zf.png" alt="">
            </div>
            <div class="tex">免费获取更多社会组织服务</div>
          </div>
          <div>
            <div class="img">
              <img src="@/assets/images/erweima_emof.jpg" alt="">
            </div>
            <div class="tex">了解更多信息化产品</div>
          </div>
        </div>
      </div>
    </div>
    <div class="end">
      Copyright © 2015-2020 EMOF
      <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(255, 255, 255);">京ICP备15038897号-3</a>
<!--      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802037085" target="_blank"-->
<!--         class="margin-lr-xs" style="color: rgb(255, 255, 255);">-->
<!--        <img src="http://www.beian.gov.cn/img/new/gongan.png" alt="">公安备案号：11010802037085</a>-->
      北京易魔方科技集团有限公司 版权所有
    </div>
  </div>
</template>
<script>
export default {
  name: "footerpage",
  data() {
    return {}
  },
  components: {},
  created() {

  },
  methods: {},
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.boxFoot {
  width: 100%;
  background-color: #0a2240;

  .boxFootLeft {


    .img {
      width: 24px;
      float: left;
      margin-top: 4px;

      img {
        width: 24px;

      }
    }

    .tex {
      display: inline-block;
      margin-left: 15px;

      .texTop {
        font-size: 18px;
        color: #fff;
      }

      .texCenter {
        font-size: 20px;
        font-weight: bold;
        color: #fff;
      }

      .texBottom {
        font-size: 14px;
        color: #bcbbbb;
      }
    }
  }

  .boxFootRight {

    height: 120px;
    margin-top: 30px;

    .img {
      width: 175px;
      height: 80px;

      img {
        display: block;
        width: 80px;
        height: 80px;
        margin: 0 auto;
      }
    }

    .tex {
      font-size: 14px;
      width: 175px;
      text-align: center;
      color: #fff;
      margin-top: 10px;
    }
  }
}

.end {
  width: 100%;
  height: 50px;
  background-color: #0a2240;
  line-height: 50px;
  font-size: 14px;
  color: #fff;
  text-align: center;

  a {
    color: #fff;
  }
}
</style>


